import { FilterState, FilterSchema } from "@jem/components";
import { JEMChecklistDetailsRow } from "@jem/components";

// eslint-disable-next-line
const toCamelCase = require("lodash/camelCase");

function filterOnSearchCriteria(searchCriteria: string | null, gridItems: JEMChecklistDetailsRow[]) {
  if (searchCriteria !== null && searchCriteria !== "") {
    const newItems: JEMChecklistDetailsRow[] = [];
    for (const row of gridItems) {
      for (const [type, value] of Object.entries(row)) {
        // everything is a string or number, if it is else then avoid
        if (typeof value === "number" || typeof value === "boolean" || typeof value === "object") {
          continue;
        }

        const colKey = type.toLowerCase();
        if (colKey.indexOf("time") !== -1) {
          const theDate = new Date(value).toLocaleDateString();
          if (theDate && theDate.toLowerCase().indexOf(searchCriteria.toLowerCase()) !== -1) {
            newItems.push(row);
            break;
          }
        } else {
          if (value && value.toLowerCase().indexOf(searchCriteria.toLowerCase()) !== -1) {
            newItems.push(row);
            break;
          }
        }
      }
    }
    return newItems;
  }
  return gridItems;
}

function filterOnCommandBarFilters(
  filtersCriteria: FilterState["filterBar"],
  filters: FilterSchema<JEMChecklistDetailsRow>[],
  gridItems: JEMChecklistDetailsRow[]
) {
  let newItems: JEMChecklistDetailsRow[] = gridItems;
  for (const filterType of filters) {
    const camelCaseFilterName = toCamelCase(filterType.filterName);
    const filterValue = filtersCriteria[`${camelCaseFilterName}Selected` as keyof FilterState["filterBar"]];
    if (filterValue !== null) {
      if (!filterValue.length) {
        // user removed all items
        return [];
      } else {
        newItems = newItems.filter((row) => {
          const filterRowName = filterType.columnName;
          if (Array.isArray(row[filterRowName as keyof JEMChecklistDetailsRow])) {
            const genericArr = row[filterRowName as keyof JEMChecklistDetailsRow] as unknown[];
            if (genericArr.every((element) => typeof element === "number")) {
              // The array is of type number[]
              const numberArr = row[filterRowName as keyof JEMChecklistDetailsRow] as number[];
              return filterValue.some((item) => numberArr.indexOf(Number(item)) !== -1);
            } else if (genericArr.every((element) => typeof element === "string")) {
              // The array is of type string[]
              const strArr = row[filterRowName as keyof JEMChecklistDetailsRow] as string[];
              return filterValue.some((item) => strArr.indexOf(item) !== -1);
            } else {
              // The array contains elements of mixed types
              console.error("Array contains mixed types... TODO?");
            }
          } else if (
            filterType.filterName.indexOf("dueDate") !== -1 &&
            row[filterRowName as keyof JEMChecklistDetailsRow]
          ) {
            const theDate = row[filterRowName as keyof JEMChecklistDetailsRow] as string;
            return filterValue.indexOf(theDate) !== -1;
          } else {
            const cell = row[filterRowName as keyof JEMChecklistDetailsRow];
            return filterValue.indexOf(cell as string) !== -1;
          }
        });
      }
    }
  }
  return newItems;
}

export function JEMChecklistDetailsFilterRows(
  filterState: FilterState,
  filters: FilterSchema<JEMChecklistDetailsRow>[],
  gridItems: JEMChecklistDetailsRow[]
): JEMChecklistDetailsRow[] {
  let newItems = gridItems;
  newItems = filterOnCommandBarFilters(filterState.filterBar, filters, newItems);
  newItems = filterOnSearchCriteria(filterState.searchCriteria, newItems);
  return newItems;
}
